import type { FollowGroup, FollowSource } from '../components/Follow'

import webIcon from 'url:../assets/web.png'
import facebookIcon from 'url:../assets/facebook.png'
import instagramIcon from 'url:../assets/instagram.png'
import xIcon from 'url:../assets/x.png'
import youtubeIcon from 'url:../assets/youtube.png'

const ENGLISH = 'follow.lang.english'
const GERMAN = 'follow.lang.german'
const UKRAINIAN = 'follow.lang.ukrainian'

const zabrisky: FollowSource = {
  key: 'zabrisky',
  langKeys: [ENGLISH],
  links: [
    {
      asset: webIcon,
      labelKey: 'help.website',
      href: 'https://euromaidanpress.com/author/zarinazabrisky/',
    },
    {
      asset: facebookIcon,
      labelKey: 'help.facebook',
      href: 'https://www.facebook.com/zarina.zabrisky',
    },
    { asset: xIcon, labelKey: 'help.x', href: 'https://x.com/ZarinaZabrisky' },
    {
      asset: instagramIcon,
      labelKey: 'help.instagram',
      href: 'https://www.instagram.com/zarinazabrisky/',
    },
    {
      asset: youtubeIcon,
      labelKey: 'help.youtube',
      href: 'https://www.youtube.com/channel/UC5clrA08fbAPLl5F5Vxlfwg',
    },
  ],
}

const naber: FollowSource = {
  key: 'naber',
  langKeys: [GERMAN],
  links: [
    { asset: webIcon, labelKey: 'help.website', href: 'https://www.welt.de/autor/ibrahim-naber/' },
    { asset: xIcon, labelKey: 'help.x', href: 'https://x.com/IbraNaber' },
    {
      asset: instagramIcon,
      labelKey: 'help.instagram',
      href: 'https://www.instagram.com/ibranaber/',
    },
  ],
}

const kelley: FollowSource = {
  key: 'kelley',
  langKeys: [ENGLISH],
  links: [
    { asset: webIcon, labelKey: 'help.website', href: 'https://brendankelley.substack.com/' },
    {
      asset: instagramIcon,
      labelKey: 'help.instagram',
      href: 'https://www.instagram.com/kelley2276/',
    },
  ],
}

const localPress: FollowGroup = {
  labelKey: 'follow.localPress',
  sources: [
    {
      key: 'vgoru',
      langKeys: [UKRAINIAN],
      links: [
        { asset: webIcon, labelKey: 'help.website', href: 'https://vgoru.org/' },
        { asset: facebookIcon, labelKey: 'help.facebook', href: 'https://www.facebook.com/vgoru/' },
        { asset: xIcon, labelKey: 'help.x', href: 'https://x.com/vgorunews' },
        {
          asset: youtubeIcon,
          labelKey: 'help.youtube',
          href: 'https://www.youtube.com/channel/UCtb5EkOIT-DfTGiMaN8G8Ug',
        },
      ],
    },
    {
      key: 'suspilne',
      langKeys: [UKRAINIAN],
      links: [
        { asset: webIcon, labelKey: 'help.website', href: 'https://suspilne.media/kherson/' },
        {
          asset: instagramIcon,
          labelKey: 'help.instagram',
          href: 'https://www.instagram.com/suspilne.kherson/',
        },
      ],
    },
    {
      key: 'most',
      langKeys: [UKRAINIAN, ENGLISH],
      links: [
        { asset: webIcon, labelKey: 'help.website', href: 'https://most.ks.ua/' },
        {
          asset: facebookIcon,
          labelKey: 'help.facebook',
          href: 'https://www.facebook.com/mostnews',
        },
        { asset: xIcon, labelKey: 'help.x', href: 'https://x.com/most_ks_ua' },
        {
          asset: instagramIcon,
          labelKey: 'help.instagram',
          href: 'https://www.instagram.com/most.ks.ua/',
        },
        {
          asset: youtubeIcon,
          labelKey: 'help.youtube',
          href: 'https://www.youtube.com/channel/UC9jfJ4UB7rS0IcOuC5NukUA',
        },
      ],
    },
  ],
}

/**
 * Right bank: the correspondents covering Kherson, then the local
 * Ukrainian-language press. Names and descriptions live in the translation
 * files under `follow.<key>`.
 */
export const khersonSources: FollowGroup[] = [{ sources: [zabrisky, naber, kelley] }, localPress]

/** Left bank: Oleshky is covered consistently only by Zabrisky. */
export const oleshkySources: FollowGroup[] = [{ sources: [zabrisky] }]
